import React from 'react';
import CustomLink from './link';

const Button = ({ size, url, emoji, children }) => {
    return (
        <CustomLink url={url} classes={`btn btn--${size}`}>
            {emoji.url !== undefined &&
                <img className='emoji' src={emoji.url} alt={emoji.alt} />
            }
            <span className='btn-text'>{children}</span>
        </CustomLink>
    )
}
export default Button